<template>
	<div id="body">
		<div class="overlay">
			<div class="container">
				<div class="row">
					<div class="col-md-6 col-sm-6">
						<div class="page-title wow bounceInLeft animated" ata-wow-delay="0.4s" >
							<h1>{{home}}</h1></div>
					</div>
					<div class="col-md-6 col-sm-6">
						<ul class="page-breadcrumb wow bounceInRight animated" ata-wow-delay="0.4s">
							<li>
								<router-link to="/index">{{lang == 1 ? '首页' : 'Home'}}</router-link>
							</li>
							<li class="active">
								<router-link to="/member">{{home}}</router-link>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
		<div class="page-seperate"></div>
		<div id="content">
			<section class="blog-section">
				<div class="container">
					<div class="row">
						<!--Blog Section-->
						<div class="col-md-12 col-xs-12">
							<article id="post-22" class="post-content-area wow fadeInDown animated post-22 page type-page status-publish hentry" data-wow-delay="0.4s">
								<div class="blog-featured-img"></div>
								<div class="post-content">
									<div class="entry-content">
										<div v-for="(item,index) in list">
											<h3>{{item.category.title}}</h3>
											<figure class="wp-block-gallery aligncenter" :class="item.category.list_num == 1 ? 'columns-1' : item.category.list_num == 2 ? 'columns-2' : item.category.list_num == 3 ? 'columns-3' : 'columns-2 vip'">
												<ul class="blocks-gallery-grid">
													<li class="blocks-gallery-item" v-for="(val,ind) in item.list">
														<a :href="val.url ? val.url : 'javascript:;'">
															<img loading="lazy" :width="item.category.list_num == 4 ? '' : 300" height="300" :src="baseUrl + val.cover_image" style="display: block;margin: 0 auto;" />
															<figcaption class="blocks-gallery-item__caption"><strong>{{val.title}}</strong></figcaption>
														</a>
													</li>
												</ul>
											</figure>
										</div>
									</div>
								</div>
							</article>
						</div>
						<!--/Blog Section-->
					</div>
				</div>
			</section>
		</div>
	</div>
</template>

<script>
	import "@/assets/css/member.css";
	import { getMember } from '../api/api';
	export default {
		data() {
			return {
				baseUrl: 'http://admin.brlsea.org',
				list: [],
				home: ''
			};
		},
		props: ['lang'],
		methods: {
			onGetData(){
				let that = this;
				getMember({
					lang: this.lang
				}).then(res=>{
					if(res.code == 1) {
						that.list = res.data;
					}
				})
			}
		},
		created() {
			this.onGetData();
		},
		mounted() {
			this.home = $(".menu-item.active a").text();
		}
	};
</script>

<style scoped="scoped">
@media (max-width: 380px) {
	.vip li{
		margin-right: 0;
		width: 100% !important;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/member.vue